/**
 * UI labels for chat models; backend `convex/agent/supportedModels.ts` is the
 * allowlist source of truth — ids here must match it or `agent.send` rejects.
 */

export type ChatModel = {
	id: string;
	label: string;
	provider: string;
};

export const CHAT_MODELS: ChatModel[] = [
	{ id: "openai/gpt-5.6-sol", label: "GPT-5.6 Sol", provider: "OpenAI" },
	{ id: "openai/gpt-5.6-terra", label: "GPT-5.6 Terra", provider: "OpenAI" },
	{ id: "openai/gpt-5.6-luna", label: "GPT-5.6 Luna", provider: "OpenAI" },
	{
		id: "google/gemini-3.1-pro-preview",
		label: "Gemini 3.1 Pro",
		provider: "Google",
	},
	{
		id: "google/gemini-3.7-flash",
		label: "Gemini 3.7 Flash",
		provider: "Google",
	},
	{
		id: "google/gemini-3-flash-preview",
		label: "Gemini 3 Flash",
		provider: "Google",
	},
	{
		id: "google/gemini-3.5-flash-lite",
		label: "Gemini 3.5 Flash Lite",
		provider: "Google",
	},
	{ id: "x-ai/grok-4.6", label: "Grok 4.6", provider: "xAI" },
	{ id: "x-ai/grok-4.5", label: "Grok 4.5", provider: "xAI" },
	{ id: "x-ai/grok-4.3", label: "Grok 4.3", provider: "xAI" },
	{ id: "moonshotai/kimi-k3", label: "Kimi K3", provider: "Moonshot" },
	{ id: "moonshotai/kimi-k2.6", label: "Kimi K2.6", provider: "Moonshot" },
	{
		id: "deepseek/deepseek-v4-pro",
		label: "DeepSeek v4 Pro",
		provider: "DeepSeek",
	},
	{
		id: "deepseek/deepseek-v4-flash-0731",
		label: "DeepSeek v4 Flash",
		provider: "DeepSeek",
	},
	{
		id: "deepseek/deepseek-v3.2-exp",
		label: "DeepSeek v3.2",
		provider: "DeepSeek",
	},
	{ id: "qwen/qwen3-235b-a22b-2507", label: "Qwen3 235B", provider: "Alibaba" },
	{
		id: "anthropic/claude-opus-5",
		label: "Claude Opus 5",
		provider: "Anthropic",
	},
	{
		id: "anthropic/claude-sonnet-5",
		label: "Claude Sonnet 5",
		provider: "Anthropic",
	},
	{
		id: "anthropic/claude-haiku-4.5",
		label: "Claude Haiku 4.5",
		provider: "Anthropic",
	},
	{ id: "minimax/minimax-m2.7", label: "MiniMax M2.7", provider: "MiniMax" },
	{ id: "z-ai/glm-5.1", label: "GLM 5.1", provider: "Zhipu" },
	{ id: "z-ai/glm-5.2", label: "GLM 5.2", provider: "Zhipu" },
	{ id: "xiaomi/mimo-v2.5-pro", label: "MiMo v2.5 Pro", provider: "Xiaomi" },
];

export const DEFAULT_CHAT_MODEL = "x-ai/grok-4.5";

export function modelLabel(id: string | undefined): string {
	if (!id) return "Default model";
	const m = CHAT_MODELS.find((x) => x.id === id);
	return m?.label ?? id;
}

export function isChatModelId(id: unknown): id is string {
	return typeof id === "string" && CHAT_MODELS.some((m) => m.id === id);
}
